var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 444,
    viewBox: "0 0 444 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444 222C444 344.607 344.607 444 222 444C99.3928 444 0 344.607 0 222C0 99.3928 99.3928 0 222 0C344.607 0 444 99.3928 444 222ZM333.292 169.434C333.292 187.16 318.921 201.53 301.195 201.53C283.469 201.53 269.099 187.16 269.099 169.434C269.099 151.707 283.469 137.337 301.195 137.337C318.921 137.337 333.292 151.707 333.292 169.434ZM142.665 203.53C160.391 203.53 174.761 189.16 174.761 171.434C174.761 153.707 160.391 139.337 142.665 139.337C124.939 139.337 110.569 153.707 110.569 171.434C110.569 189.16 124.939 203.53 142.665 203.53ZM221.733 318.957C221.753 318.957 221.773 318.957 221.793 318.957C264.78 318.957 278.171 315.194 295.969 291.105C296.964 289.758 298.462 288.856 300.124 288.649L303.014 288.287C307.639 287.709 311.101 292.41 308.971 296.556C290.669 332.179 269.407 338.019 222.01 338.97C222.003 338.973 222 338.975 222 338.975C221.965 338.974 221.93 338.973 221.896 338.973C221.861 338.973 221.827 338.974 221.793 338.975C221.793 338.975 221.79 338.973 221.783 338.97C174.386 338.019 153.124 332.179 134.821 296.556C132.691 292.41 136.154 287.709 140.779 288.288L143.669 288.649C145.331 288.857 146.829 289.758 147.824 291.105C165.585 315.144 178.957 318.941 221.733 318.957Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happy-face.431500561bd29ff25d77929e18457b6d.svg";
export { ForwardRef as ReactComponent };